import superConfigApi from "./api";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialSuperConfig = {
  superConfig: {},
  isLoading: false,
  isProcessing: false,
  isCompleted: false,
};

const superConfig = createSlice({
  name: "super-configs",
  initialState: initialSuperConfig,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsProcessing: (state, action) => {
      state.isProcessing = action.payload;
    },
    setSuperConfig: (state, action) => {
      state.superConfig = action.payload;
    },
  },
});

const { reducer, actions } = superConfig;

export const { setIsLoading, setIsProcessing, setSuperConfig } = actions;

export const fetchSuperConfig = () => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const data = await superConfigApi.getConfig();
      dispatch(setSuperConfig(data.data));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};

export const updateSuperConfig = (config) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await superConfigApi.updateConfig(config);
      if (data.error) {
        toast.error(data.error.msg);
      } else {
        dispatch(setSuperConfig(data.data));
        toast.success("Thiết lập cấu hình thành công!");
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export default reducer;
